export const SELECT_QUIZ_TASK_ITEM = 'SELECT_QUIZ_TASK_ITEM';
export const OPEN_QUIZ_STAGE = 'OPEN_QUIZ_STAGE';
export const SET_QUIZ_STATE = 'SET_QUIZ_STATE';
export const CLEAR_QUIZ_STATE = 'CLEAR_QUIZ_STATE';
export const SUBMIT_QUIZ_ANSWERS = 'SUBMIT_QUIZ_ANSWERS';
export const EXIT_QUIZ = 'EXIT_QUIZ';
export const SET_PREVIOUS_QUIZ_RESULTS = 'SET_PREVIOUS_QUIZ_RESULTS';

import { QUIZ_REWARDS_KEY, QUIZ_STAGE_KEY } from './reducers';

/**
 * Select a task item to do work on in the current quiz state.
 */
export function selectQuizTaskItem(item) {
    return { type: SELECT_QUIZ_TASK_ITEM, item };
}

/**
 * Transition to a quiz stage, prompting the user based on the
 * transition from their current stage.
 */
export function openQuizStage(stage, options = {}) {
    return { type: OPEN_QUIZ_STAGE, stage, options };
}

/**
 * Set the value of the state field for an quiz task.
 */
export function setQuizTaskStage(taskId, value) {
    return { type: SET_QUIZ_STATE, taskId, key: QUIZ_STAGE_KEY, value };
}

/**
 * Set the value of the rewards field for a quiz task.
 */
export function setQuizRewards(taskId, value) {
    return { type: SET_QUIZ_STATE, taskId, key: QUIZ_REWARDS_KEY, value };
}

/**
 * Clear the state of a quiz task.
 */
export function clearQuizState(taskId) {
    return { type: CLEAR_QUIZ_STATE, taskId };
}

/**
 * Submit the answers for all of the items in the quiz
 * task and finish the quiz.
 */
export function submitQuizAnswers(taskId) {
    return { type: SUBMIT_QUIZ_ANSWERS, taskId };
}

/**
 * Exit quiz mode and return to the task view.
 */
export function exitQuiz(taskId) {
    return { type: EXIT_QUIZ, taskId };
}

/**
 * Stores the previous results of quizzes.
 */
export function setPreviousQuizResults(results) {
    return { type: SET_PREVIOUS_QUIZ_RESULTS, results };
}
